module.exports = __webpack_public_path__ + "static/media/scan-data.bb8fcb3d.png";